<div class="mail-card">
    <div class="mail-card__topbar">
        <span>Project budget overview</span>
        <span>Resumo.io</span>
    </div>

    <div class="mail-card__header">
        <img
            src="/assets/img/logo-.png"
            alt="Resumo logo"
            class="mail-card__logo" />
        <h2 class="mail-card__title">Project budget overview</h2>
        <p class="mail-card__subtitle">All current ongoing project budgets are shown below, sorted by usage percentage.</p>
    </div>

    <div *ngIf="isLoading" class="m-t-2 p-3">
        <app-loading-message></app-loading-message>
    </div>

    <ng-container *ngIf="!isLoading">
        <div
            *ngIf="!report || (report.projectAccountAlerts.length === 0 && report.invoiceContractAlerts.length === 0 && report.uncheckedProjectAccountRows.length === 0)"
            class="mail-card__section">
            <div class="mail-card__empty">No current ongoing project budget lines were found.</div>
        </div>

        <div
            *ngIf="report?.uncheckedProjectAccountRows?.length > 0"
            class="mail-card__section">
            <div class="mail-card__notice">
                Some project account budgets could not be checked from Tempo worklogs. They are listed below instead of being treated as below
                threshold.
            </div>
        </div>

        <div
            *ngIf="report?.projectAccountAlerts?.length > 0"
            class="mail-card__section">
            <h3 class="mail-card__section-title">accounts (Tempo)</h3>
            <table class="mail-table">
                <thead>
                    <tr>
                        <th class="text-left">Project</th>
                        <th class="text-left">Account</th>
                        <th class="text-right">Used</th>
                        <th class="text-right">Budget</th>
                        <th class="text-right">Usage</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let alert of report.projectAccountAlerts">
                        <td class="text-left">{{ alert.projectTitle }}</td>
                        <td class="text-left mail-table__muted">{{ alert.sourceLabel }}</td>
                        <td class="text-right">{{ alert.amount | number: '1.2-2' }}</td>
                        <td class="text-right">{{ alert.budget | number: '1.2-2' }}</td>
                        <td
                            class="text-right mail-table__usage"
                            [class.mail-table__usage--over]="alert.usagePercentage >= 100">
                            {{ alert.usagePercentage | number: '1.2-2' }}%
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td
                            colspan="2"
                            class="text-left">
                            Totaal
                        </td>
                        <td class="text-right">{{ report.totals.accountTotalUsed | number: '1.2-2' }}</td>
                        <td class="text-right">{{ report.totals.accountTotalBudget | number: '1.2-2' }}</td>
                        <td class="text-right mail-table__muted">{{ report.totals.accountTotalRemaining | number: '1.2-2' }} resterend</td>
                    </tr>
                </tfoot>
            </table>
        </div>

        <div
            *ngIf="report?.invoiceContractAlerts?.length > 0"
            class="mail-card__section">
            <h3 class="mail-card__section-title">contract (by invoice)</h3>
            <table class="mail-table">
                <thead>
                    <tr>
                        <th class="text-left">Project</th>
                        <th class="text-right">Invoiced</th>
                        <th class="text-right">Budget</th>
                        <th class="text-right">Usage</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let alert of report.invoiceContractAlerts">
                        <td class="text-left">{{ alert.projectTitle }}</td>
                        <td class="text-right">{{ alert.amount | number: '1.2-2' }}</td>
                        <td class="text-right">{{ alert.budget | number: '1.2-2' }}</td>
                        <td
                            class="text-right mail-table__usage"
                            [class.mail-table__usage--over]="alert.usagePercentage >= 100">
                            {{ alert.usagePercentage | number: '1.2-2' }}%
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td class="text-left">Totaal</td>
                        <td class="text-right">{{ report.totals.contractTotalUsed | number: '1.2-2' }}</td>
                        <td class="text-right">{{ report.totals.contractTotalBudget | number: '1.2-2' }}</td>
                        <td class="text-right mail-table__muted">{{ report.totals.contractTotalRemaining | number: '1.2-2' }} resterend</td>
                    </tr>
                </tfoot>
            </table>
        </div>

        <div
            *ngIf="report?.uncheckedProjectAccountRows?.length > 0"
            class="mail-card__section">
            <h3 class="mail-card__section-title">not checked (project accounts / worklogs)</h3>
            <table class="mail-table">
                <thead>
                    <tr>
                        <th class="text-left">Project</th>
                        <th class="text-left">Project account</th>
                        <th class="text-right">Budget</th>
                        <th class="text-left">Period</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of report.uncheckedProjectAccountRows">
                        <td class="text-left">{{ row.projectTitle }}</td>
                        <td class="text-left mail-table__muted">{{ row.sourceLabel }}</td>
                        <td class="text-right">{{ row.budget | number: '1.2-2' }}</td>
                        <td class="text-left mail-table__muted">{{ row.period }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div
            *ngIf="report?.totals?.grandTotalBudget > 0"
            class="mail-card__section">
            <div class="grand-total-box">
                <div class="grand-total-box__header">Totaal openstaande budgetten</div>
                <div class="grand-total-box__body">
                    <div class="grand-total-box__row">
                        <span>Totaal gebruikt</span>
                        <span class="grand-total-box__value">{{ report.totals.grandTotalUsed | number: '1.2-2' }}</span>
                    </div>
                    <div class="grand-total-box__row">
                        <span>Totaal budget</span>
                        <span class="grand-total-box__value">{{ report.totals.grandTotalBudget | number: '1.2-2' }}</span>
                    </div>
                    <div class="grand-total-box__row grand-total-box__row--remaining">
                        <span>Nog resterend</span>
                        <span
                            class="grand-total-box__value"
                            [class.grand-total-box__value--negative]="report.totals.grandTotalRemaining < 0"
                            [class.grand-total-box__value--positive]="report.totals.grandTotalRemaining >= 0">
                            {{ report.totals.grandTotalRemaining | number: '1.2-2' }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="mail-card__cta">
            <a
                routerLink="/projects"
                class="mail-card__cta-button">
                Open project overview
            </a>
        </div>
    </ng-container>
</div>
